import { createSlice } from "@reduxjs/toolkit";
import { getAllSettings } from "../actions/getAllSettings";
import { PURGE } from "redux-persist";
import { set } from "lodash";

const initialState = {
    loading: 'idle',
    hasError: false,
    errorMessage: '',
    data: [],
    settingsMap: {
        companyLogoUrl: null,
        currencySymbol: "$",

    }
}
const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        resetState: () => {
            return initialState;
        }

    },
    extraReducers: (builder) => {
        builder.addCase(PURGE, () => {
            return initialState;
        })
            .addCase(getAllSettings.pending, (state) => {
                state.loading = 'pending';
                state.hasError = false
                state.errorMessage = '';
                state.data = [] ;
            })
            .addCase(getAllSettings.fulfilled, (state, action) => {
                state.loading = 'succeeded';
                state.hasError = false;
                state.data = action.payload;
                state.errorMessage = "";
                state.settingsMap = {
                    companyLogoUrl: action.payload.find(setting => setting.name === 'companyLogo')?.value
                        ? action.payload.find(setting => setting.name === 'companyLogo')?.value
                        : null,
                    currencySymbol: action.payload.find(setting => setting.name === 'currencySymbol')?.value
                        ? action.payload.find(setting => setting.name === 'currencySymbol')?.value
                        : "$",
                }



            })
            .addCase(getAllSettings.rejected, (state, action) => {
                state.loading = 'failed';
                state.hasError = true;
                state.errorMessage = action.payload
                state.data = [];
            })
    }   
});

export const { resetState } = settingsSlice.actions;
export default settingsSlice.reducer;